import { useState, useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';

import { siteboardAction, setProfileDialogueShowing } from '../actions/defaultActions';
import { SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, SET_WELCOME_DIALOGUE_OPEN, CREATE_TRIAL_SUBSCRIPTION } from '../actions/types';

import PopupWindow from './PopupWindow';
import TrialSubscriptionCard from './TrialSubscriptionCard';
import SubscriptionPaymentCard from './SubscriptionPaymentCard';
import StandardSubscriptionCard from './StandardSubscriptionCard';

const SubscriptionChooserPopup = ({ siteboardAction, setProfileDialogueShowing }) => {
  const SUBSCRIPTION_PAGE = 'SUBSCRIPTION_PAGE';
  const CHOOSE_PLAN_PAGE = 'CHOOSE_PLAN_PAGE';
  const [currentPage, setCurrentPage] = useState(CHOOSE_PLAN_PAGE);
  const containerRef = useRef(null);

  useEffect(() => {
    if(containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [currentPage]);

  const closeDialogue = () => {
    siteboardAction(SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, { isOpen: false });
  };

  const onTrialClicked = () => {
    const onSuccess = () => { 
      closeDialogue();
      setProfileDialogueShowing(false);
      siteboardAction(SET_WELCOME_DIALOGUE_OPEN, { isOpen: true }); 
    };
    siteboardAction(CREATE_TRIAL_SUBSCRIPTION, {}, onSuccess);
  };
  const onStandardClicked = () => {
    setCurrentPage(SUBSCRIPTION_PAGE);
  };

  const onBackButton = currentPage === CHOOSE_PLAN_PAGE ? null : () => {
    setCurrentPage(CHOOSE_PLAN_PAGE);
  };

  return (
    <PopupWindow title={currentPage === CHOOSE_PLAN_PAGE ? 'Choose a Plan' : 'Payment'} onBackButton={onBackButton} closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='flex flex-col text-white'>
        {currentPage === CHOOSE_PLAN_PAGE &&
          <div className='flex flex-col md:flex-row justify-center gap-y-[20px] gap-x-[20px] w-full text-[1.2em]'>
            <TrialSubscriptionCard onClicked={onTrialClicked} />
            <StandardSubscriptionCard onClicked={onStandardClicked} />
          </div>
        }
        {currentPage === SUBSCRIPTION_PAGE &&
          <div className='animate-right-fade'>
            <SubscriptionPaymentCard />
          </div>
        }
      </div>
    </PopupWindow>
  );
};

const mapStateToProps = state => { return { // define redux state that will be passed in as props
}};
export default connect(mapStateToProps, { siteboardAction, setProfileDialogueShowing })(SubscriptionChooserPopup);
